var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,9.11c0,4.61-4.69,5.27-4.74,5.28H15.8a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.4c.09,0,3.8-.56,3.8-4.28a4.29,4.29,0,0,0-4.44-4.28.46.46,0,0,1-.47-.28A6.19,6.19,0,0,0,5.32,6.82a.52.52,0,0,1-.19.37.5.5,0,0,1-.41.09A3.09,3.09,0,0,0,1,10.3a2.87,2.87,0,0,0,.78,2.14,3.93,3.93,0,0,0,2.54,1H7.19a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H4.31a4.9,4.9,0,0,1-3.22-1.23A3.85,3.85,0,0,1,0,10.3,4.08,4.08,0,0,1,4.38,6.23a7.18,7.18,0,0,1,13.47-2.4A5.27,5.27,0,0,1,23,9.11ZM11.85,7.84a.64.64,0,0,0-.16-.11.5.5,0,0,0-.38,0,.64.64,0,0,0-.16.11l-3,3a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0L11,9.4v9.79a.5.5,0,0,0,1,0V9.4l2.15,2.15a.51.51,0,0,0,.7,0,.5.5,0,0,0,0-.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.0c1b45a213f3919f18472c9d2ba36e57.svg";
export { ForwardRef as ReactComponent };